/* eslint-disable tailwindcss/no-arbitrary-value */

import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import { PageHeaderBackground } from '$/(cms)/_modules/cmsService/types';

export const GradientBackground: React.FC<PageHeaderBackground> = (
  header_background,
) => {
  const { background_image, background } = header_background ?? {};

  const imageSource = background_image ?? background?.image;

  return (
    <div className="relative">
      {imageSource?.url && (
        <div className="absolute inset-0 -z-1 h-63 overflow-hidden md:h-65 lg:h-70">
          <CmsImage
            src={imageSource.url}
            alt={imageSource.alternativeText ?? ''}
            fill
            loading="eager"
            fetchPriority="high"
            sizes={{ _: '100vw' }}
            className="object-cover object-bottom"
          />
        </div>
      )}

      <div
        className="absolute inset-0 -z-1 h-63 md:h-65 lg:h-70"
        style={{
          background:
            'linear-gradient(180deg, rgba(250, 250, 250, 0) 10%, #FAFAFA 100%)',
        }}
      />
    </div>
  );
};
